import {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';

const classNamespace = 'search-form';
const fieldsClassName = `${classNamespace}__fields`;
const detailsFieldsClassName = `${classNamespace}__details-fields`;

function useComponent() {
    const {
        formOptions: {
            showGuestsDetailsInputField,
            showSubmitDetailsButtonField
        }
    } = useSearchFormContext();

    const className = classNames(fieldsClassName, detailsFieldsClassName);

    const result = {
        className,
        showGuestsDetailsInputField,
        showSubmitDetailsButtonField
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
